// extracted by mini-css-extract-plugin
module.exports = {"Order":"Order_Order__3Rc_6","LineItem":"Order_LineItem__1eteo","PurchaserName":"Order_PurchaserName__3pslv","ItemName":"Order_ItemName__2-J4B"};